import { wrapperCall, isDataAvailable } from "../utils";
import LicenseeLineRowData from "./rows/LicenseeLineRowData";
import LicenseeLineColumns from "./columns/LicenseeLineColumn";
import DJAALinesRowData from "./rows/DJAALinesRowData";
import DJAALinesColumns from "./columns/DJAALinesColumn";
import FTPLinesRowData from "./rows/FTPLinesRowData";
import FTPLinesColumns from "./columns/FTPLinesColumn";
import WizardLinesRowData from "./rows/WizardLinesRowData";
import WizardLinesColumns from "./columns/WizardLinesColumn";
import BuyLinesRowData from "./rows/BuyLinesRowData";
import BuyLinesColumns from "./columns/BuyLinesColumn";
import SellLinesRowData from "./rows/SellLinesRowData";
import SellLinesColumns from "./columns/SellLinesColumn";
import BudResLinesRowData from "./rows/BudResLinesRowData";
import BudResLinesColumns from "./columns/BudResLinesColumn";
import ARAPLinesRowData from "./rows/ARAPLinesRowData";
import ARAPLinesColumns from "./columns/ARAPLinesColumn";
import APLinesRowData from "./rows/APLinesRowData";
import APLinesColumns from "./columns/APLinesColumn";
import CRSLinesRowData from "./rows/CRSLinesRowData";
import CRSLinesColumns from "./columns/CRSLinesColumn";
import AmadeusLinesRowData from "./rows/AmadeusLinesRowData";
import AmadeusLinesColumns from "./columns/AmadeusLinesColumn";
import MeiliLinesRowData from "./rows/MeiliLinesRowData";
import MeiliLinesColumns from "./columns/MeiliLinesColumn";

export async function getDetailData(token, info, setRowData, setColumnDefs, setNoData, navigate) {
    const _interface = info['intType'] || "default";

    switch(_interface.toUpperCase()) {
        case 'LICENSEEFEE':
            try {
                const response = await wrapperCall('readLicenseeFeeEntries', info, token, 'json', navigate);
                const length = response.data.length;
                let dataAvailable = true;

                if(length === 1) {
                    dataAvailable = isDataAvailable(response.data[0]);
                } 

                if(dataAvailable) {
                    storeLicenseeFeeLines(response.data, setRowData);
                    setColumnDefs(LicenseeLineColumns);
                    setNoData(false);
                } else {
                    setNoData(true);
                }
            } catch (error) {
                console.log(error);
            }
            break;

        case 'DJAA':
            try {
                const response = await wrapperCall('readDJAAEntries', info, token, 'json', navigate);
                const length = response.data.length;
                let dataAvailable = true;

                if(length === 1) {
                    dataAvailable = isDataAvailable(response.data[0]);
                } 

                if(dataAvailable) {
                    storeDJAALines(response.data, setRowData);
                    setColumnDefs(DJAALinesColumns);
                    setNoData(false);
                } else {
                    setNoData(true);
                }
            } catch (error) {
                console.log(error);
            }
            break;

        case 'FTP':
        case 'FTPLITE':
        case 'FTPBUDGET':
            try {
                const response = await wrapperCall('readFTPEntries', info, token, 'json', navigate);
                const length = response.data.length;
                let dataAvailable = true;

                if(length === 1) {
                    dataAvailable = isDataAvailable(response.data[0]);
                } 

                if(dataAvailable) {
                    storeFTPLines(response.data, setRowData);
                    setColumnDefs(FTPLinesColumns);
                    setNoData(false);
                } else {
                    setNoData(true);
                }
            } catch (error) {
                console.log(error);
            }         
            break;

        case 'WIZARD':
            try {
                const response = await wrapperCall('readWizardEntries', info, token, 'json', navigate);
                const length = response.data.length;
                let dataAvailable = true;

                if(length === 1) {
                    dataAvailable = isDataAvailable(response.data[0]);
                } 

                if(dataAvailable) {
                    storeWizardLines(response.data, setRowData);
                    setColumnDefs(WizardLinesColumns);
                    setNoData(false);
                } else {
                    setNoData(true);
                }
            } catch (error) {
                console.log(error);
            }
            break;

        case 'BUY':
            try {
                const response = await wrapperCall('readBuyEntries', info, token, 'json', navigate);
                const length = response.data.length;
                let dataAvailable = true;

                if(length === 1) {
                    dataAvailable = isDataAvailable(response.data[0]);
                } 

                if(dataAvailable) {
                    storeBuyLines(response.data, setRowData);
                    setColumnDefs(BuyLinesColumns);
                    setNoData(false);
                } else {
                    setNoData(true);
                }
            } catch (error) {
                console.log(error);
            }
            break;

        case 'SELL':
            try {
                const response = await wrapperCall('readSellEntries', info, token, 'json', navigate);
                const length = response.data.length;
                let dataAvailable = true;

                if(length === 1) {
                    dataAvailable = isDataAvailable(response.data[0]);
                } 

                if(dataAvailable) {
                    storeSellLines(response.data, setRowData);
                    setColumnDefs(SellLinesColumns);
                    setNoData(false);
                } else {
                    setNoData(true);
                }
            } catch (error) {
                console.log(error);
            }
            break;

        case 'BUDGETRES':
        case 'BUDGET RES':
            try {
                const response = await wrapperCall('readBudResEntries', info, token, 'json', navigate);
                const length = response.data.length;
                let dataAvailable = true;

                if(length === 1) {
                    dataAvailable = isDataAvailable(response.data[0]);
                } 

                if(dataAvailable) {
                    storeBudResLines(response.data, setRowData);
                    setColumnDefs(BudResLinesColumns);
                    setNoData(false);
                } else {
                    setNoData(true);
                }
            } catch (error) {
                console.log(error);
            }
            break;

        case "OVERRIDE":
        case "AR BULK":
        case "AP BULK":
            try {
                const response = await wrapperCall('readARAPEntries', info, token, 'json', navigate);
                const length = response.data.length;
                let dataAvailable = true;

                console.log(response.data);

                if(length === 1) {
                    dataAvailable = isDataAvailable(response.data[0]);
                } 

                if(dataAvailable) {
                    const filteredColumns = filterARAPLinesColumns(response.data[0], ARAPLinesColumns);
                    setColumnDefs(filteredColumns);
                    storeARAPLines(response.data, setRowData);
                    setNoData(false);
                } else {
                    setNoData(true);
                }
            } catch (error) {
                console.log(error);
            }
            break;

        case 'AVISPLUS':
            try {
                const response = await wrapperCall('readAPEntries', info, token, 'json', navigate);
                const length = response.data.length;
                let dataAvailable = true;

                if(length === 1) {
                    dataAvailable = isDataAvailable(response.data[0]);
                } 

                if(dataAvailable) {
                    storeAPLines(response.data, setRowData);
                    setColumnDefs(APLinesColumns);
                    setNoData(false);
                } else {
                    setNoData(true);
                }
            } catch (error) {
                console.log(error);
            }
            break;

        case 'CRS':
            try {
                const response = await wrapperCall('readCRSEntries', info, token, 'json', navigate);
                const length = response.data.length;
                let dataAvailable = true;

                if(length === 1) {
                    dataAvailable = isDataAvailable(response.data[0]);
                } 

                if(dataAvailable) {
                    storeCRSLines(response.data, setRowData);
                    setColumnDefs(CRSLinesColumns);
                    setNoData(false);
                } else {
                    setNoData(true);
                }
            } catch (error) {
                console.log(error);
            }
            break;

        case 'AMADEUS':
            try {
                const response = await wrapperCall('readAmadeusEntries', info, token, 'json', navigate);
                const length = response.data.length;
                let dataAvailable = true;

                if(length === 1) {
                    dataAvailable = isDataAvailable(response.data[0]);
                } 

                if(dataAvailable) {
                    storeAmadeusLines(response.data, setRowData);
                    setColumnDefs(AmadeusLinesColumns);
                    setNoData(false);
                } else {
                    setNoData(true);
                }
            } catch (error) {
                console.log(error);
            }
            break;

        case 'MEILI':
            try {
                const response = await wrapperCall('readMeiliEntries', info, token, 'json', navigate);
                const length = response.data.length;
                let dataAvailable = true;

                if(length === 1) {
                    dataAvailable = isDataAvailable(response.data[0]);
                }

                if(dataAvailable) {
                    storeMeiliLines(response.data, setRowData);
                    setColumnDefs(MeiliLinesColumns);
                    setNoData(false);
                } else {
                    setNoData(true);
                }
            } catch (error) {
                console.log(error);
            }
            break;

        default:
            console.log("No matching found");
            setNoData(true);
    }
}

function storeLicenseeFeeLines(rows, setRowData) {
    let licenseeFeeLines = [];
    rows.forEach(element => readLicenseeFeeLines(element, licenseeFeeLines));
    const plainData = licenseeFeeLines.map((entry) => ({ ...entry }));
    setRowData(plainData);
}

function readLicenseeFeeLines(value, licenseeFeeLines) {
    const licenseeFeeEntry = new LicenseeLineRowData(value);
    licenseeFeeLines.push(licenseeFeeEntry);
}

function storeDJAALines(rows, setRowData) {
    let dJAALines = [];
    rows.forEach(element => readDJAALines(element, dJAALines));
    const plainData = dJAALines.map((entry) => ({ ...entry }));
    setRowData(plainData);
}

function readDJAALines(value, dJAALines) {
    const dJAAEntry = new DJAALinesRowData(value);
    dJAALines.push(dJAAEntry);
}

function storeFTPLines(rows, setRowData) {
    let fTPLines = [];
    rows.forEach(element => readFTPLines(element, fTPLines));
    const plainData = fTPLines.map((entry) => ({ ...entry }));
    setRowData(plainData);
}

function readFTPLines(value, fTPLines) {
    const fTPEntry = new FTPLinesRowData(value);
    fTPLines.push(fTPEntry);
}

function storeWizardLines(rows, setRowData) {
    let wizardLines = [];
    rows.forEach(element => readWizardLines(element, wizardLines));
    const plainData = wizardLines.map((entry) => ({ ...entry }));
    setRowData(plainData);
}

function readWizardLines(value, wizardLines) {
    const wizardEntry = new WizardLinesRowData(value);
    wizardLines.push(wizardEntry);
}

function storeBuyLines(rows, setRowData) {
    let buyLines = [];
    rows.forEach(element => readBuyLines(element, buyLines));
    const plainData = buyLines.map((entry) => ({ ...entry }));
    setRowData(plainData);
}

function readBuyLines(value, buyLines) {
    const buyEntry = new BuyLinesRowData(value);
    buyLines.push(buyEntry);
}

function storeSellLines(rows, setRowData) {
    let sellLines = [];
    rows.forEach(element => readSellLines(element, sellLines));
    const plainData = sellLines.map((entry) => ({ ...entry }));
    setRowData(plainData);
}

function readSellLines(value, sellLines) {
    const sellEntry = new SellLinesRowData(value);
    sellLines.push(sellEntry);
}

function storeBudResLines(rows, setRowData) {
    let budResLines = [];
    rows.forEach(element => readBudResLines(element, budResLines));
    const plainData = budResLines.map((entry) => ({ ...entry }));
    setRowData(plainData);
}

function readBudResLines(value, budResLines) {
    const budResEntry = new BudResLinesRowData(value);
    budResLines.push(budResEntry);
}

function storeARAPLines(rows, setRowData) {
    let aRAPLines = [];
    rows.forEach(element => readARAPLines(element, aRAPLines));
    const plainData = aRAPLines.map((entry) => ({ ...entry }));
    setRowData(plainData);
}

function readARAPLines(value, aRAPLines) {
    const aRAPEntry = new ARAPLinesRowData(value);
    aRAPLines.push(aRAPEntry);
}

function storeAPLines(rows, setRowData) {
    let aPLines = [];
    rows.forEach(element => readAPLines(element, aPLines));
    const plainData = aPLines.map((entry) => ({ ...entry }));
    setRowData(plainData);
}

function readAPLines(value, aPLines) {
    const aPEntry = new APLinesRowData(value);
    aPLines.push(aPEntry);
}

function storeCRSLines(rows, setRowData) {
    const cRSLines = [];
    rows.forEach(element => readCRSLines(element, cRSLines));
    const plainData = cRSLines.map((entry) => ({ ...entry }));
    setRowData(plainData);
}

function readCRSLines(value, cRSLines) {
    const cRSEntry = new CRSLinesRowData(value);
    cRSLines.push(cRSEntry);
}

function storeAmadeusLines(rows, setRowData) {
    const amadeusLines = [];
    rows.forEach(element => readAmadeusLines(element, amadeusLines));
    const plainData = amadeusLines.map((entry) => ({ ...entry }));
    setRowData(plainData);
}

function readAmadeusLines(value, amadeusLines) {
    const amadeusEntry = new AmadeusLinesRowData(value);
    amadeusLines.push(amadeusEntry);
}

function storeMeiliLines(rows, setRowData) {
    const meiliLines = [];
    rows.forEach(element => readMeiliLines(element, meiliLines));
    const plainData = meiliLines.map((entry) => ({ ...entry }));
    setRowData(plainData);
}

function readMeiliLines(value, meiliLines) {
    const meiliEntry = new MeiliLinesRowData(value);
    meiliLines.push(meiliEntry);
}

function filterARAPLinesColumns(row, columns) {
    const filteredColumns = columns.filter((entry) => {
        const field = entry['field'];

        return row[field]  &&  row[field].length > 0;
    });

    return filteredColumns;
}